<template>
  <section class="welcome">
    <div class="container">
      <div class="row align-items-center text-center text-lg-left">
        <div class="col-md-6 order-1 order-md-2 text-center">
          <img src="@/assets/img/get-the-power.png" class="img img-fluid" alt="Conquiste o poder digital com a CyberClass" />
        </div>
        
        <div class="col-md-6 order-2 order-md-1 title">
          <h1>Conquiste o poder do digital</h1>
          <StartNowButton />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StartNowButton from "@/components/buttons/StartNowButton"

export default {
  components: {
    StartNowButton,
  },
}
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .welcome {
    padding-top: 60px;
    margin-bottom: 80px;

    @media (max-width: $mobileBreakpoint) {
      padding-top: 40px;
    }

    .img {
      max-width: 620px;

      @media (max-width: $tabletBreakpoint) {
        max-width: 100%
      }
    }
    
    .title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 40px;

      @media (max-width: $mobileBreakpoint) {
        margin-top: 43px;
      }

      h1 {
        text-align: left;
      }
    }
  }
</style>
